import { IMPORTANCE_STYLES } from "../../lib/intelApi";

export default function ImportanceBadge({ level, className = "" }) {
  return (
    <span
      data-testid="importance-badge"
      className={`inline-flex items-center font-mono text-[10px] uppercase tracking-[0.22em] px-2 py-1 border ${
        IMPORTANCE_STYLES[level] || IMPORTANCE_STYLES.Low
      } ${className}`}
    >
      {level}
    </span>
  );
}
